import { render, staticRenderFns } from "./MpExternalForm.vue?vue&type=template&id=5ba8185a&scoped=true"
import script from "./MpExternalForm.vue?vue&type=script&lang=js"
export * from "./MpExternalForm.vue?vue&type=script&lang=js"
import style0 from "./MpExternalForm.vue?vue&type=style&index=0&id=5ba8185a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba8185a",
  null
  
)

export default component.exports